import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || "Google sign-in failed. Please try again.";
        navigate("/login", { replace: true, state: { error: msg } });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F4EF]">
      <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#8A8F84] animate-pulse">Signing you in…</span>
    </div>
  );
}
